import { render, staticRenderFns } from "./AddEditTraining.vue?vue&type=template&id=1f4d7fb4"
import script from "./AddEditTraining.vue?vue&type=script&lang=js"
export * from "./AddEditTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports